import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const updatePlatformConfigs = (payload, callback) => {
  return async (dispatch) => {
    dispatch({ type: 'UPDATING_PLATFORM_CONFIGS' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.put(`/ads/platform-config`, payload, {
            params: {
              requestId: reqId,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          if (response.status === 200) {
            await dispatch({
              type: 'UPDATING_PLATFORM_CONFIGS_DONE',
              payload: {
                promptId: response?.data,
              },
            });
            if (typeof callback === 'function') {
              callback();
            }
          } else {
            dispatch({
              type: 'UPDATING_PLATFORM_CONFIGS_FAILED',
              payload: `Failed to update platform configs`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'UPDATING_PLATFORM_CONFIGS_FAILED',
            payload: `Failed to update platform configs`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'UPDATING_PLATFORM_CONFIGS_FAILED',
        payload: `Failed to update platform configs`,
      });
    }
  };
};

export default updatePlatformConfigs;
